define([
    'system/domain/entity/relation-marks-pattern',
    'underscore'
], function(
    Pattern
    )
{
    var rawTypes = {
        link: {
            name: 'Link',
            marks: Pattern.arrow
        },
        trace: {
            name: 'Trace',
            marks: Pattern.arrow
        },
        derive: {
            name: 'Derive',
            marks: Pattern.arrow
        },
        cont: {
            name: 'Containment',
            marks: Pattern.cross
        },
        dreq: {
            name: 'Derived',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
        satisfy: {
            name: 'Satisfy',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
        refine: {
            name: 'Refine',
            marks: Pattern.arrow
        },
        next: {
            name: 'Next',
            marks: Pattern.arrow
        },
        action: {
            name: 'Link',
            marks: Pattern.arrow
        },
        affiliation: {
            name: 'Affiliation',
            faicon: 'fa fa-sitemap',
            marks: Pattern.cross
        },
        information: {
            name: 'Information',
            faicon: 'fa fa-info-circle',
            marks: Pattern.arrow
        },
        money: {
            name: 'Money',
            faicon: 'fa fa-jpy',
            marks: Pattern.arrow
        },
        logistics: {
            name: 'Logistics',
            faicon: 'fa fa-truck',
            marks: Pattern.arrow
        },
        analyze: {
            name: 'Supported by',
            marks: Pattern.arrow
        },
        because: {
            name: 'In Context of',
            marks: Pattern.arrow
        },
        belong: {
            name: 'Belong',
            marks: Pattern.cross
        },
        transition: {
            name: 'Transition',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
        include: {
            name: 'Include',
            marks: Pattern.arrow
        },
        'communication-path': {
            name: 'Link',
            marks: Pattern.arrow
        },
        TestTree_Include: {
            name: 'Include',
            marks: Pattern.diamond
        },
        verify: {
            name: 'Verify',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
        ControlFlow: {
            name: 'Control Flow',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
        ObjectFlow: {
            name: 'Object Flow',
            marks: Pattern.arrow
        },
        Part: {
            name: 'Part Association',
            marks: [{
                type: 'diamond',
                circle: false,
                offset: {
                    y: 16
                },
                size: 2.0,
                angleOffset: 0,
                position: 1.0
            }],
            multiplicity: {
                target: {
                    lower: 0,
                    upper: 1
                },
                source: {
                    lower: 1,
                    upper: 1
                }
            }
        },
        Shared: {
            name: 'Shared Association',
            marks: [{
                type: 'diamond',
                className: 'mark-nofill',
                circle: false,
                offset: {
                    y: 32
                },
                size: 2.0,
                angleOffset: 0,
                position: 1.0
            }],
            multiplicity: {
                target: {
                    lower: 0,
                    upper: 1
                },
                source: {
                    lower: 1,
                    upper: 1
                }
            }
        },
        Reference: {
            name: 'Reference Association',
            marks: Pattern.arrow,
            multiplicity: {
                target: {
                    lower: 1,
                    upper: 1
                },
                source: {
                    lower: 1,
                    upper: 1
                }
            }
        },
        Generalization: {
            name: 'Generalization',
            marks: [{
                type: 'triangle',
                className: 'mark-nofill',
                circle: false,
                offset: {
                    y: 32
                },
                size: 2.0,
                angleOffset: 0,
                position: 1.0
            }]
        },
        Aggregation: {
            name: 'Aggregation',
            marks: [{
                type: 'diamond',
                className: 'mark-nofill',
                circle: false,
                offset: {
                    y: 32
                },
                size: 2.0,
                angleOffset: 0,
                position: 1.0
            }],
            multiplicity: {
                target: {
                    lower: 1,
                    upper: 1
                },
                source: {
                    lower: 1,
                    upper: 1
                }
            }
        },
        Composition: {
            name: 'Composition',
            marks: [{
                type: 'diamond',
                circle: false,
                offset: {
                    y: 16
                },
                size: 2.0,
                angleOffset: 0,
                position: 1.0
            }],
            multiplicity: {
                target: {
                    lower: 1,
                    upper: 1
                },
                source: {
                    lower: 1,
                    upper: 1
                }
            }
        },
        Association: {
            name: 'Association',
            marks: Pattern.arrow,
            multiplicity: {
                target: {
                    lower: 1,
                    upper: 1
                },
                source: {
                    lower: 1,
                    upper: 1
                }
            }
        },
        Realization: {
            name: 'Realization',
            lineType: 'dashed',
            marks: [{
                type: 'triangle',
                className: 'mark-nofill',
                circle: false,
                offset: {
                    y: 32
                },
                size: 2.0,
                angleOffset: 0,
                position: 1.0
            }]
        },
        Dependency: {
            name: 'Dependency',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
        Nest: {
            name: 'Nest',
            marks: Pattern.cross
        },
        Import: {
            name: '<<Import>>',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
        Merge: {
            name: '<<Merge>>',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
        CircuitConnected: {
            name: 'Connected'
        },
        CircuitRectified: {
            name: 'Rectified',
            marks: Pattern.arrow
        },
        CircuitSignal: {
            name: 'Signal',
            lineType: 'dashed',
            marks: Pattern.arrow
        },
    };

    var types = [];
    _.each(rawTypes, function(obj, type) {
        var d = _.extend({}, obj);
        d.id = type;
        d.type = type;
        types.push(d);
    });

    return types;
});



// WEBPACK FOOTER //
// ./system/domain/entity/default-relation-types.js